import React from 'react';
import s from './Slot.module.css';

type VideoSlotProps = {
    url?: string | null;
    poster?: string;
    className?: string;
};

const areEqual = (prev: VideoSlotProps, next: VideoSlotProps) =>
    prev.url === next.url && prev.poster === next.poster;

const VideoSlot: React.FC<VideoSlotProps> = React.memo(({ url, poster, className }) => {
    if (!url) {
        return <div className={`${s.slot} ${s.empty}`}>No video</div>;
    }

    return (
        <div className={`${s.slot} ${className ?? ''}`}>
            <video
                key={url}
                src={url}
                poster={poster}
                controls
                playsInline
                preload="metadata"
                style={{ width: '100%', height: '100%', objectFit: 'cover', background: '#000' }}
            />
        </div>
    );
}, areEqual);

export default VideoSlot;
